import './ThemeSwitch.scss';

export { default } from './ThemeSwitch';
